/* eslint-disable import/order */
import {X, FileText, Image as ImageIcon} from "lucide-react";
import type {UploadedFile} from "@hooks/use-file-upload";

interface FilePreviewProps {
    files: UploadedFile[];
    onRemove: (fileId: string) => void;
}

export function FilePreview({files, onRemove}: FilePreviewProps) {
    if (files.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2 px-4 pt-2">
            {files.map((file) => (
                <div
                    key={file.id}
                    className="flex items-center gap-1 bg-muted rounded-md px-2 py-1 text-xs"
                >
                    {file.isImage ? (
                        <ImageIcon className="size-3"/>
                    ) : (
                        <FileText className="size-3"/>
                    )}
                    <span className="max-w-32 truncate">{file.filename}</span>
                    <button
                        onClick={() => onRemove(file.id)}
                        className="ml-1 hover:text-destructive"
                    >
                        <X className="size-3"/>
                    </button>
                </div>
            ))}
        </div>
    );
}
